export const images = [
    "https://media.gettyimages.com/photos/workshop-involving-digital-media-in-a-junior-high-school-with-les-picture-id1036181272?s=2048x2048",
    "https://media.gettyimages.com/photos/programming-code-abstract-screen-of-software-devoloper-picture-id1086741568?s=2048x2048",
    "https://media.gettyimages.com/photos/adding-modifications-to-their-latest-code-picture-id935964092?s=2048x2048",
    "https://wallpaperplay.com/walls/full/f/a/7/77644.jpg",
    "https://wallpaperplay.com/walls/full/f/d/a/77607.jpg",
    "https://images4.alphacoders.com/665/thumb-1920-665092.jpg"
]
